module.exports = __webpack_public_path__ + "img/lin_icon.a611f125.svg";